<af-main-container #mainContainer
                   [title]="contactDetailsId
                       ? ('i18n_af_labelContactDetailsId' | translate:{contactDetailsId: contactDetailsId})
                       : ('i18n_af_labelCreateContactDetails' | translate)"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [filterNavigationPath]="Path.CONTACT_DETAILS"
                   [specialFilter]="filter"
                   [customNavigateToPath]="customNavigateToPath"
                   [queryParamsHandling]="'merge'"
                   [navigateBackListener]="navigateBack"
                   spinnerIds="initial">
    <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <ui-kit-button type="secondary"
                       spinnerId="saveEdit"
                       [label]="'i18n_af_buttonCancel' | translate"
                       (clickListener)="mainContainer.breadcrumbs.navigateBack()"/>
        <ui-kit-button spinnerId="saveEdit"
                       [label]="'i18n_af_buttonSave' | translate"
                       (clickListener)="save()"/>
    </div>
    @if (contactDetailsResponse || !contactDetailsId) {
        <af-contact-details-step class="w-100 mt-24 overflow-y-scroll"
                                 [mode]="contactDetailsId ? 'edit' : 'create'"
                                 [form]="form"
                                 [contactDetailsResponse]="contactDetailsResponse"/>
    }
</af-main-container>
